<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="文档类型" prop="docType" required>
        <el-select v-model="form.docType" placeholder="请选择文案类型" @change="handleDocTypeChange">
          <el-option v-for="item in $consts.DOCUMENT_TYPES" :key="item.value" :value="item.value" :label="item.name"/>
        </el-select>
      </el-form-item>
      <el-form-item label="作用域" prop="scope" required>
        <BookScopeSelect :doc-type="form.docType" v-model="form.scope" @change="handleScopeChange"/>
      </el-form-item>
      <el-form-item label="文案类型" prop="type" required>
        <BookTextTypeSelect v-if="template != null" :template="template.code" :doc-type="form.docType" :scope="form.scope" v-model="form.type"/>
      </el-form-item>
      <el-form-item label="内容" prop="content" required>
        <el-input type="textarea" v-model="form.content" :maxlength="inputMaxLength" show-word-limit placeholder="请输入文案内容"/>
      </el-form-item>
      <p style="color: #999;font-size: 13px;">提示：当前文案类型可在文案内容中使用以下变量</p>
      <el-table
        v-if="variables.length > 0"
        :data="variables"
        stripe
      >
        <el-table-column prop="variable" label="变量" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="描述" min-width="100px"></el-table-column>
      </el-table>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import BookScopeSelect from './BookScopeSelect'
import BookTextTypeSelect from './BookTextTypeSelect'
import { fetchByKey } from '@/api/system/config'
export default {
  name: 'OperaBookTextListWindow',
  extends: BaseOpera,
  components: { BookTextTypeSelect, BookScopeSelect, GlobalWindow },
  props: {
    template: {
      required: true
    }
  },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        type: '_platform',
        content: '',
        docType: 'ZBS',
        scope: 'TEMPLATE'
      },
      // 内容字数限制，从配置中读取
      inputMaxLength: null,
      // 招标书数据
      zbsData: null,
      // 说明书数据
      introduceData: null,
      // 验证规则
      rules: {
        content: [
          { required: true, message: '请输入文案内容' }
        ]
      }
    }
  },
  computed: {
    variables () {
      return this.$consts.TEMPLATE_CONFIG[this.template.code][`${this.form.docType}_${this.form.scope}_VARIABLES`]
    }
  },
  watch: {
    'form.type': {
      immediate: true,
      handler () {
        // 说明书
        if (this.form.docType === 'ZBS' && this.zbsData != null) {
          if (this.form.scope === 'TEMPLATE') {
            const length = this.zbsData.inputLimit.template[this.form.type]
            const defaultLength = this.zbsData.inputLimit.template.default
            this.inputMaxLength = length == null ? defaultLength : length
          }
          if (this.form.scope === 'MODULE') {
            const length = this.zbsData.inputLimit.module[this.form.type]
            const defaultLength = this.zbsData.inputLimit.module.default
            this.inputMaxLength = length == null ? defaultLength : length
          }
        }
        // 说明文档
        else if (this.form.docType === 'SYS_INT' && this.introduceData != null) {
          if (this.form.scope === 'TEMPLATE') {
            const length = this.introduceData.inputLimit.template[this.form.type]
            const defaultLength = this.introduceData.inputLimit.template.default
            this.inputMaxLength = length == null ? defaultLength : length
          }
          if (this.form.scope === 'MODULE') {
            const length = this.introduceData.inputLimit.module[this.form.type]
            const defaultLength = this.introduceData.inputLimit.module.default
            this.inputMaxLength = length == null ? defaultLength : length
          }
        }
      }
    }
  },
  methods: {
    // 处理切换文档类型
    handleDocTypeChange () {
      this.form.scope = 'TEMPLATE'
      this.handleScopeChange()
    },
    // 处理切换作用域
    handleScopeChange () {
      // 招标书
      if (this.form.docType === 'ZBS') {
        if (this.form.scope === 'TEMPLATE') {
          this.form.type = this.zbsData.scopes[0].textTypes[0].type
        }
        if (this.form.scope === 'MODULE') {
          this.form.type = this.zbsData.scopes[1].textTypes[0].type
        }
        return
      }
      // 系统说明书
      if (this.form.docType === 'SYS_INT') {
        if (this.form.scope === 'TEMPLATE') {
          this.form.type = this.introduceData.scopes[0].textTypes[0].type
        }
        if (this.form.scope === 'MODULE') {
          this.form.type = this.introduceData.scopes[1].textTypes[0].type
        }
      }
    },
    // 配置说明书
    configIntroduce () {
      fetchByKey('book:system:introduce:config')
        .then(data => {
          this.introduceData = JSON.parse(data.value)
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 配置招标书
    configZbs () {
      fetchByKey('book:zbs:config')
        .then(data => {
          this.zbsData = JSON.parse(data.value)
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 确认
    confirm () {
      if (this.form[this.configData['field.id']] == null || this.form[this.configData['field.id']] === '') {
        const form = JSON.parse(JSON.stringify(this.form))
        form.templateId = this.template.id
        this.__confirmCreate(form)
        return
      }
      this.__confirmEdit()
    }
  },
  created () {
    this.configIntroduce()
    this.configZbs()
    this.config({
      api: '/book/text',
      'field.id': 'id'
    })
  }
}
</script>
